module.exports = "/fonts/ElevanceSans-Medium.a0a8c5064f4eb9649db26833e1eca2a6.woff";